import { Pipe, PipeTransform } from '@angular/core';
import { EmployeeRequestApprovalPolicyEnum, EmployeeRequestApprovalPolicyEnumLabels } from '../enums/employee-request-approval-policy.enum';

@Pipe({
  name: 'employeeRequestApprovalPolicy',
  pure: true,
})
export class EmployeeRequestApprovalPolicyPipe implements PipeTransform {
  transform(value: EmployeeRequestApprovalPolicyEnum): string {
    return EmployeeRequestApprovalPolicyEnumLabels[value];
  }
}
